import { useEffect, useRef, useState } from "react";

export const CountrySelect = ({ id, testid, value, onChange, options, placeholder, className, required, dark }) => {
  const [q, setQ] = useState(value || "");
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);
  useEffect(() => setQ(value || ""), [value]);

  const term = q.trim().toLowerCase();
  const filtered =
    open && term && q !== value
      ? [
          ...options.filter((c) => c.toLowerCase().startsWith(term)),
          ...options.filter((c) => !c.toLowerCase().startsWith(term) && c.toLowerCase().includes(term)),
        ]
      : options;

  const pick = (c) => {
    onChange(c);
    setQ(c);
    setOpen(false);
  };

  const panelCls = dark
    ? "absolute left-0 right-0 top-full mt-1 max-h-56 overflow-y-auto bg-[#0A0A0A] border border-gray-700 z-30 shadow-[0_16px_32px_rgba(0,0,0,0.5)]"
    : "absolute left-0 right-0 top-full mt-1 max-h-56 overflow-y-auto bg-white border border-border z-30 shadow-[0_12px_24px_rgba(0,0,0,0.12)]";
  const optCls = (selected) =>
    dark
      ? `w-full text-left px-3.5 py-2.5 text-xs font-mono-tech text-white border-b border-gray-800 last:border-b-0 hover:bg-gray-900 hover:text-yellow-500 transition-colors ${selected ? "text-yellow-500 font-semibold" : ""}`
      : `w-full text-left px-4 py-2 text-xs text-gray-950 border-b border-border last:border-b-0 hover:bg-gray-50 transition-colors ${selected ? "bg-yellow-50 font-semibold" : ""}`;

  return (
    <div className="relative" ref={boxRef}>
      <input
        id={id}
        data-testid={testid}
        value={q}
        required={required}
        autoComplete="off"
        placeholder={placeholder}
        className={className}
        onFocus={() => setOpen(true)}
        onChange={(e) => {
          setQ(e.target.value);
          setOpen(true);
          if (!e.target.value.trim() && value) onChange("");
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" && open && filtered.length > 0) {
            e.preventDefault();
            pick(filtered[0]);
          }
          if (e.key === "Escape") setOpen(false);
        }}
        onBlur={() => {
          setOpen(false);
          setQ(value || "");
        }}
      />
      {open && filtered.length > 0 && (
        <div className={panelCls} data-testid={`${testid}-options`}>
          {filtered.map((c, i) => (
            <button
              key={c}
              type="button"
              data-testid={`${testid}-option-${i}`}
              onMouseDown={(e) => {
                e.preventDefault();
                pick(c);
              }}
              className={optCls(c === value)}
            >
              {c}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
